import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=5ad6434c&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad6434c')) {
      api.createRecord('5ad6434c', component.options)
    } else {
      api.reload('5ad6434c', component.options)
    }
    module.hot.accept("./PageHeading.vue?vue&type=template&id=5ad6434c&", function () {
      api.rerender('5ad6434c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/PageHeading.vue"
export default component.exports